export const crew = {
    labels: {
        advanced_filters: "Advanced Filters",
        availability: "Availability",
        candidates: "Candidates",
        crew: "Crew Member",
        find_crew: "Find Crew",
        experience: "Experience",
        location: "Location",
        jobs: "Vacancies",
        position: "Position",
        register_cv: "Register CV",
        register_vacancy: "Register Vacancy",
        clear_filter: "Clear Filters",
        apply_filter: "Apply Filters",
        view_profile: "View Profile",
    },
    placeholders: {
        availability: "How soon?",
        experience: "What experience?",
        location: "Where?",
        position: "What position are you looking for?",
    },
    texts: {
        crew_filter_title: "Fill in the filters and check out the professionals available on our platform.",
        empty_list: "No candidates were found for your search!",
    },
};
